import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgForOf, NgIf } from "@angular/common";

@Component({
  selector: 'app-metrics-item',
  templateUrl: './metrics-item.html',
  standalone: true,
  imports: [
    NgForOf,
    NgIf
  ],
  styleUrls: ['./metrics-item.scss']
})
export class MetricsItemComponent {

    @Input() public backgroundColors: string[] = [];
    @Input() public mainMetricValue = '';
    @Input() public mainMetricUnit: string = '';
    @Input() public title = '';
    @Input() public legend: string  = '';

    @Output() public onClicked: EventEmitter<any> = new EventEmitter<any>();
}
